/**
 * 録音後 / SOAP 生成中 / SOAP 表示統合画面の dispatcher.
 *
 * user.yakureki_setting.transcription_mode に応じて legacy / streaming の
 * 実装をそのまま呼び出す薄い dispatcher。中の component は自身の mode を
 * 意識しない.
 *
 * 拡張は legacy/ または streaming/ 配下で行う:
 * - legacy/  = Gemini 同期経路 (batch モード) の UI。SOAP 生成中オーバーレイ
 *              も legacy 側の実装を維持する
 * - streaming/ = Chirp Streaming 経路の UI (今後、SOAP 生成中の逐次 transcript
 *                表示や話者分離トグル等を拡張)
 */
import { FC } from 'react'
import { Yakureki, YakurekiDetail } from '@/shared/types/yakurekiCore'
import { useMyPharmacyQuery } from '@/features/yakureki/hooks/queries/useMyPharmacyQuery'
import { PostRecordingConfirmationScreen as LegacyPostRecordingScreen } from './legacy/screens/PostRecordingScreen'
import { StreamingPostRecordingScreen } from './streaming/screens/PostRecordingScreen'

export interface PostRecordingScreenProps {
  selectedPatient?: Yakureki
  patientList: Yakureki[]
  patientDetail: YakurekiDetail
  renderEditableModal: () => React.ReactNode
  reloadPatientDetail: () => Promise<void>
  onRegenerateSOAP: () => Promise<void>
}

export const PostRecordingScreen: FC<PostRecordingScreenProps> = (props) => {
  const { transcriptionMode } = useMyPharmacyQuery()
  if (transcriptionMode === 'streaming') {
    return <StreamingPostRecordingScreen {...props} />
  }
  return <LegacyPostRecordingScreen {...props} />
}
